import { useMemo, useState } from 'react';
import { useTranslation } from '../../../../lib/i18n';
import { inlinePreviewDocument, type EmailCampaignPreviewCardData } from '../../../../lib/email-review';
import { useEmailCampaignInlinePreview } from '../../../../lib/email-review-api';
import { useIsPhone } from '../../../../lib/use-is-phone';
import { InlineHtmlPreview } from './InlineHtmlPreview';

const EMAIL_WIDTH = 700;
const PHONE_WIDTH = 375;

export function EmailCampaignInlinePreview({
  workspaceId,
  card,
  cardKey,
}: {
  workspaceId: string;
  card: EmailCampaignPreviewCardData;
  cardKey: string;
}) {
  const { t } = useTranslation();
  const [seen, setSeen] = useState(false);
  const phone = useIsPhone();
  const preview = useEmailCampaignInlinePreview({ workspaceId, metaSiteId: card.metaSiteId, campaignId: card.campaignId }, cardKey, seen);
  const html = useMemo(() => (preview.data ? inlinePreviewDocument(preview.data.html) : undefined), [preview.data]);
  return (
    <InlineHtmlPreview
      html={html}
      title={card.subject || t('emailReview.card.title')}
      naturalWidth={phone ? PHONE_WIDTH : EMAIL_WIDTH}
      status={t(preview.isError ? 'emailReview.unavailable' : 'emailReview.loading')}
      failed={preview.isError}
      onSeen={() => setSeen(true)}
      testId="emailCampaignInlinePreview"
    />
  );
}
